import * as actions from "./actionsTypes";

const initialData = {
  loaderHoliday: false,
  holiday: null,
  holidaysFail: null,
  saveLoaderHoliday: false,
  holidayFormError: null,
  holidayAnio: null,
};

export default function HolidayReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_HOLIDAYS:
      return { ...state, loaderHoliday: action.payload };

    case actions.GET_HOLIDAYS:
      return { ...state, holiday: action.payload.holiday, holidayAnio: action.payload.holidayAnio };

    case actions.HOLIDAYS_FAIL:
      return { ...state, holidayFail: action.payload };

    case actions.SAVE_LOADER_HOLIDAYS:
      return { ...state, saveLoaderHoliday: action.payload };

    case actions.FORM_HOLIDAYS_FAIL:
      return { ...state, holidayFormError: action.payload };

    default:
      return state;
  }
}
